import React from "react";
import { 
  RiLockLine, 
  RiRobotLine, 
  RiDragMove2Line, 
  RiCloudLine, 
  RiFileCodeLine, 
  RiSettings3Line, 
  RiDeviceLine 
} from 'react-icons/ri';

export default function WhyChoose() {
  const whyChooseData = [
    {
      icon: <RiLockLine />,
      title: "Immutable Infrastructure ",
      description:
        "Ensure consistent, predictable, and reliable deployments by adopting a gold-standard model where infrastructure remains unchanged throughout its lifecycle.",
    },
    {
      icon: <RiRobotLine />,
      title: "Autonomous AI Agents",
      description:
        "Deploy AI-powered agents that execute complex tasks, automate workflows, and enhance productivity.",
    },
    {
      icon: <RiDragMove2Line />,
      title: "Drag-and-Drop Design Interface",
      description:
        "Visually architect cloud infrastructure with an intuitive, no-code interface that simplifies complex infrastructure management.",
    },
    {
      icon: <RiCloudLine />,
      title: "Multi-Cloud & Hybrid Cloud Support  ",
      description:
        "Seamlessly design, deploy, and manage cloud infrastructure across AWS, Azure, GCP, and private clouds without vendor lock-in.",
    },
    {
      icon: <RiFileCodeLine />,
      title: "Multi-IaC Generation",
      description:
        "Design once, deploy anywhere with AeroInfra Vue’s capability to generate Terraform, CloudFormation, Pulumi, and other Infrastructure-as-Code (IaC) templates.",
    },
    {
      icon: <RiSettings3Line />,
      title: "DevOps-Ready Automation",
      description:
        "Integrated with CI/CD pipelines, enabling GitOps, automated infrastructure testing, and policy enforcement for compliance-driven deployments.",
    },
    {
      icon: <RiDeviceLine />,
      title: "Cross-Platform Flexibility",
      description:
        "Build adaptable and scalable infrastructure that evolves with your enterprise’s changing cloud needs.",
    },
  ];
  return (
    <div className="px-4 py-4 my-auto md:px-12 md:py-12 bg-[#F7F7FC]">
      <div className="flex flex-col mb-6 pb-12 justify-center lg:justify-center lg:flex-row md:mb-8">
        <h2 className="max-w-lg font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
          <span className="inline-block mb-1 sm:mb-4">Why Choose AeroInfra Vue?</span>
          <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
        </h2>
      </div>
      <div className="flex flex-wrap justify-center gap-10">
        {whyChooseData.map((item, index) => (
          <div
            key={index}
            className="card w-[400px] border border-primary shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
          >
            <div className="card-body items-center text-center">
              <div className="text-4xl text-primary mb-4">{item.icon}</div>
              <h3 className="card-title text-xl mb-2">{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
